import React, { useEffect, useState } from "react";
import SingleTogglePopup from "./SingleTogglePopup";
import SelectedDepartmentList from "./SelectedDepartmentList";
import styled from "styled-components";
import DepartmentModal from "./DepartmentModal";
import { useTranslation } from "react-i18next";

const AddSingleDepartment = ({
  mainParents,
  title,
  icon,
  selPlaceholder,
  setSelectedItem,
  selectedItem,
  //   onUserAdd,
}) => {
  const { t } = useTranslation();
  const [optionsList, setOptionsList] = useState(mainParents);
  const [selectedMainParents, setSelectedMainParents] = useState([]);
  const [pendingSelection, setPendingSelection] = useState(null);
  const [showDepartmentModal, setShowDepartmentModal] = useState(false);

  const handleAddUserClick = () => {
    if (pendingSelection) {
      //   onUserAdd(pendingSelection);
      setSelectedItem(pendingSelection.id);
      setSelectedMainParents([pendingSelection]);
      setPendingSelection(null);
      setShowDepartmentModal(false);
    }
  };

  const handleRemoveClick = () => {
    setSelectedMainParents([]);
    setPendingSelection(null);
    setSelectedItem(null);
  };
  useEffect(() => {
    if (mainParents) setOptionsList(mainParents || []);
  }, [mainParents]);

  // useEffect(() => {
  //   if (selectedItem && optionsList.length > 0) {
  //     const selectedItm = optionsList.find(
  //       (item) => parseInt(item.id) === parseInt(selectedItem)
  //     );
  //     setSelectedMainParents([selectedItm]);
  //   }
  // }, [selectedItem, optionsList]);

  useEffect(() => {
    if (selectedItem && optionsList.length > 0) {
      const selectedItm = optionsList.find(
        (item) => parseInt(item.id, 10) === parseInt(selectedItem, 10)
      );
      setSelectedMainParents(selectedItm ? [selectedItm] : []);
    } else {
      setSelectedMainParents([])
    }
  }, [selectedItem, optionsList]);

  useEffect(() => {
    if (pendingSelection) {
      const matchingOption = optionsList.find(
        (item) => parseInt(item.id, 10) === parseInt(pendingSelection.id, 10)
      );
      if (!matchingOption) {
        setPendingSelection(null);
      }
    }
  }, [pendingSelection, optionsList]);

  return (
    <MultiOptionRow>
      <SelectedDepartmentList
        selectedMainParents={selectedMainParents}
        onRemoveClick={handleRemoveClick}
      />
      {selectedMainParents.length === 0 && (
        <>
          <SingleTogglePopup
            icon={icon}
            selPlaceholder={t(selPlaceholder)}
            setShowDepartmentModal={setShowDepartmentModal}
          />
          <DepartmentModal
            title={t(title)}
            show={showDepartmentModal}
            onHide={() => setShowDepartmentModal(false)}
            mainParents={optionsList}
            pendingSelection={pendingSelection}
            setPendingSelection={setPendingSelection}
            handleAddUserClick={handleAddUserClick}
          />
        </>
      )}
    </MultiOptionRow>
  );
};

export default AddSingleDepartment;

const MultiOptionRow = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
`;
